import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonItem,
  IonLabel,
} from "@ionic/react";
import HeaderComponent from "../components/HeaderComponent";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const UserMgmt: React.FC = () => {
  const [userMetadata, setUserMetadata] = useState<any>({});
  const [adminRole, setAdminRole] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const userMetadataReduxStore = useSelector(
    (state: any) => state.userMetadata
  );
  useEffect(() => {
    if (userMetadata !== undefined) {
      setUserMetadata(userMetadataReduxStore);
      setUserEmail(userMetadata?.user?.email);
      setAdminRole(userMetadata?.userMetadata?.admin);
      // console.log(userMetadata?.userMetadata?.allowedDevicesCollections);
    }
  }, [userMetadata]);
  return (
    <IonContent fullscreen>
      <HeaderComponent title={"IAM - Identity and Access Management"} />
      <IonCard className="ion-padding" color="light">
        <IonCardTitle>Welcome {userEmail}</IonCardTitle>
        <IonCardContent>
          <IonCardSubtitle>
            Your role is &nbsp;
            <b>{adminRole ? "administrator" : "user"}</b>
            <br />
            {!adminRole ? (
              <p>You can view devices data only!</p>
            ) : (
              <>You can add devices: Premium feature - Subscribe!</>
            )}
          </IonCardSubtitle>
        </IonCardContent>
      </IonCard>
    </IonContent>
  );
};

export default UserMgmt;
